export default __webpack_public_path__ + "static/media/cancelTuoMin.15904ff0.gif";